module.exports = __webpack_public_path__ + "img/stacky.a3c049d5.jpg";